// #region Imports

import chroma from 'chroma-js';

// #endregion

/**
 * Generates a material color palette based on the given hex color.
 * @param hexColor
 * @returns
 */
export function generateMaterialPalette(hexColor: string): Record<string, string> {
    const baseLight = chroma('#ffffff');
    const baseDark = chroma('#000000');

    const palette: Record<string, string> = {};
    const steps = [0, 50, 100, 200, 300, 400, 500, 600, 700, 800, 900];
    const amounts = [0, 12, 30, 50, 70, 85, 100, 87, 70, 54, 25];

    steps.forEach((step, i) => {
        const base = step <= 500 ? baseLight : baseDark;
        palette[`${step}`] = chroma.mix(base, hexColor, amounts[i] / 100, 'rgb').hex();
    });

    return palette;
}
